/**
 * Терпимый маппер TrialFeaturesResponse → TrialFeature[] (общий для GET
 * и PATCH — оба возвращают полный каталог).
 */

import type {TrialFeature} from './types';

type Raw = Record<string, unknown>;
const asObj = (v: unknown): Raw | null => (typeof v === 'object' && v !== null ? (v as Raw) : null);
const asStr = (v: unknown): string => (typeof v === 'string' ? v : '');

export const toTrialFeatures = (raw: Raw): TrialFeature[] =>
  (Array.isArray(raw.items) ? raw.items : [])
    .map((v) => {
      const r = asObj(v);
      if (r === null) return null;
      return {
        id: asStr(r.id),
        key: asStr(r.key),
        groupKey: asStr(r.groupKey),
        description: asStr(r.description),
        inTrial: r.inTrial === true,
      };
    })
    .filter((f): f is TrialFeature => f !== null && f.key !== '');
